const PREFIX = 'admin';

export const ADMIN_SESSION_STORAGE_KEYS = {
  LAST_LOCATION: `${PREFIX}_last_location`
};
